// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//export const APIURL='https://connect360.azure-api.net/'
// export const APIURL='https://connect360-stg.azure-api.net'
export const APIURL='https://lsapimdev.azure-api.net'
export const DEVAPIURL= 'https://lsapimdev.azure-api.net'
export const SUBDOMAIN_CHECK_API = 'http://setuphub.lincsell.com/handleFolderRequest.php'
export const environment = {
  production: false,
  apiUrl: APIURL,
  staging: false,
  // Fallback only — StripeCardService.createSetupIntent() normally uses the PublishableKey
  // returned per-request by v3/subscription/payment-method; this covers a response that omits it.
  StripePublishableKey: 'pk_test_TYooMQauvdEDq54NiTphI7jx',
  currencyConfig: {
    autoByIp: true,
    defaultCurrencyCode: 'USD',
    defaultCountryCode: 'US',
    ipCountryLookupUrl: 'https://ipwho.is/'
  },
subdomainCheckApi: 'http://setuphub.lincsell.com/handleFolderRequest.php',
// };
// export const environment = {
  // production: false,
  // Target for the "Sign up" link on the signin page. An absolute http(s) URL is treated as
  // an external hand-off (the marketing pricing page, which funnels into signup); anything
  // else is navigated as an in-app route, keeping you on the current origin/environment.
  SignupURL: '/signup',
  AzureAPIURLForLogin: DEVAPIURL+"/auth-svc/api/SignIn",
  AzureAPIURL: DEVAPIURL+"/auth-svc/api/SignIn",
  AzureUserInfo: DEVAPIURL+"/account-svc/api/B2CGraphClientApi",
  BaseURL: DEVAPIURL+"/auth-svc/api/",
  AuthenticationURL: DEVAPIURL+"/auth-svc/api/",
  BusinessBaseURL: DEVAPIURL+"/account-svc/api/",
  ValidateUserEmailForBusiness: "IsUserExist",
  CreateOwnerAccount: "SignUpByEmail",
  SetupBusiness: "SetBusinessInfo",
  UploadStoreContentFile: "StoreContent/Upload",
  SaveEditStorePopupPreference: "SaveEditStorePopupPreferenceAsync",
  CreateLocation: "SetLocationSetup",
  EditLocationSetup: "EditLocationSetup",
  GetAllLocations: "GetLocationSetup",
  CustomerFunctionalityBaseURL: APIURL+"/customer-svc/api/",
  GetCustomer: "Customer",
  CompanyExistCheck: "IsCompanyExist",
  StoreEditorBaseURL: "https://editor.lincsell.com/",
  InventoryBaseURL: DEVAPIURL+"/inventory-svc/api/",
  InventoryBaseURLSTG: DEVAPIURL+"/inventory-svc/api/",
  InventoryBaseURLDebug: "http://192.168.1.99/api/",
  
  GetDepartmentList: "v1/Department",
  ChangeOrderStatus: "ChangeOrderStatus",
  CreateDepartment: "Department",
  CategoriesUrl: "Category",
  VendorURL: "Vendor",
  GetCustomerGroup: "CustomerGroups",
  CustomerBaseURL: APIURL+"/customer-svc/api/",
  GetCustomerURL: "Customer",
  SearchCustomerURL: "SearchCustomer",
  OrderBaseURL: APIURL+"/order-svc/api/",
  GetInvoiceByInvoiceNumber: "Invoice/GetOrderByInvoiceNo",
  GetRoles: "GetBusinessRoles",
  GetRights: "GetBusinessRights",
  GetRightsGroup: "GetBusinessRightsGroup",
  GetMeasuringUnit: "Unit",
  GetManufacturer: "Manufacturer",
  ItemModule: "Item",
  CloudStorageBaseURL: APIURL+"/storage-svc/api/",
  UploadProductFile: "Upload/ProductImage",
  AddQuantity: "AddQuantity",
  GetStockStatus: "GetStockStatus",
  GetPurchaseHistory: "Invoice/GetInvoice",
  GeneralDetail: "Items/GeneralDetail",
  GetIndustryList: "GetIndustry",
  SaveDirectPurchaseData: "Purchase/DirectPurchase",
  GetPurchase: "Purchase/GetPurchaseOrders",
  SearchInvoiceByCustomerId: "Invoice/GetInvoiceByCustId",
  GetByBarcode: "InventoryItem/GetByBarcode",
  PurchaseOrder: "Purchase/PurchaseOrder",
  GetStockStatusReport: "GetStockStatusReport",
  InventoryVerificationCount: "InventoryVerificationCount",
  GetTopWidgets: "Dashboard/GetTopWidgets",
    GetTopWidgetsV3: "v3/Dashboard/GetTopWidgets",
  SearchPurchaseOrder: "Purchase/SearchPurchaseOrder",
  GetGoodsReceivingNoteByPO: "Purchase/GetGoodsReceivingNoteByPO",
  GetDailyCustomers: "Dashboard/GetDailyCustomers",
  GetDailySales: "Dashboard/GetDailySales",
  GetTopSoldProducts: "Dashboard/GetTopSoldProducts",
  GetLowStockProducts: "Dashboard/GetLowStockProducts",
  Report: "Reports/GetReport",
  SessionTimeOut: "24",
  TimeOutUnit: "hours",
  SetBusinessConfig: "SetBusinessConfig",
  SubscriptionPlanList: "GetSubscriptions",
  GetHardwarePackages: "GetHardwarePackages",
  GetHardwarePackagesv2: "GetHardwarePackagesv2",
  GetSupportPackages: "GetSupportPackages",
  SetBTaxConfig: "SetBTaxConfig",
  SetBPrintingConfig: "SetBPrintingConfig",
  SetBCashDropConfig: "SetBCashDropConfig",
  SetBusinessRoles: "SetBusinessRoles",
  EditBusinessRoles: "EditBusinessRoles",
  DeleteBusinessRoles: "DeleteBusinessRoles",
  SetBusinessInfoRuntime: "SetBusinessInfoRuntime",
  SetCreditcardProcessing: "SetCreditcardProcessing",
  AddBulkEmployees: "AddBulkEmployees",
  SetBusinessWizardFinished: "SetBusinessWizardFinished",
  SetBusinessConfigWizard: "SetBusinessConfigWizard",
  SetBusinessConfigComplete: "SetBusinessConfigComplete",
  GETUSERBYUSERNAME: "GETUSERBYUSERNAME",
  GetCreditcardProcessing: "GetCreditcardProcessing",
  ForgotPassword: "ForgetPassword",
  GetBusinessConfig: "GetBusinessConfig",
  SetBusinessConfigCompleted: "SetBusinessConfigCompleted",
  SetTaxConfig: "SetTaxConfig",
  SetCashHandlingConfig: "SetCashHandlingConfig",
  SetPrintingConfig: "SetPrintingConfig",
  SetCashDropConfig: "SetCashDropConfig",
  SetCashDrawerConfig: "SetCashDrawerConfig",
  SetSecurityConfig: "SetSecurityConfig",
  SetTenderScreenConfig: "SetTenderScreenConfig",
  GetLocationSetup: "GetLocationSetup",
  EmailForCustomPlan: "EmailForCustomPlan",
  CreateBusinessUser: "CreateBusinessUser",
  FinishSignUpProcess: "FinishSignUpProcess",
  ActivateUserAccount: "ActivateUserAccount",
  CreateBusinessInfo: "CreateBusinessInfo",
  GetIndustries: "GetIndustries",
  GetPurchaseOrders: "Purchase/GetPurchaseOrders",
  GetCurrency: "GetCurrency",
  SetBusinessCurrency: "/business/currency",
  GetDefaultLanguages: "GetDefaultLanguages",
  UpdateProfileImage: "Upload/ProfileImage",
  GetRegisters: "GetRegisters",
  SetRegisterStatus: "SetRegisterStatus",
  GoodsReceivingNote: "Purchase/GoodsReceivingNote",
  ImportInventory: "Item/ImportInventoryItems",
  ZipInfoService: "ZipInfoService",

  FinishSignUpProcessV3 : "FinishSignUpProcessV4",

  GetCashierList: "/Filters/GetCashierList",
  AuthorizeEnvironment: "testing", // authorize.net environment configuration
  CancelPurchaseOrder: "Purchase/CancelPurchaseOrder",
  TransferStock: "Transfer/StockTransfer",
  GetTransferList: "Transfer/GetStockTransfers",
  FilterInvoiceHistory: "Invoice/FilterInvoice",
  SearchStockTransfer: "Transfer/SearchStockTransfer",
  GetPurchaseOrderItems: "/Purchase/GetPurchaseOrderItems",
  AuthorizeMerchantURL: "https://apitest.authorize.net/xml/v1/request.api",

  SetTenderOtherCharges: "SetTenderOtherCharges",
  GetTenderOtherCharges: "GetTenderOtherCharges",
  GetByFilterValue: "FilterItems",
  AssignCustomerToGroup: "CustomerGroups/Assignment",
    GetAssignedCustomers: 'GetCustomersByGroupId',
    GetAssignedCustomersListV2: 'GetCustomerIdsByGroupId',
    AUTHORIZE_NET_PAYMENT_URL: "https://test.authorize.net/payment/payment",
    AUTHORIZE_NET_PAYMENT_CHANGE_CC_URL: "https://test.authorize.net/payment/payment",
    AUTHORIZE_NET_API_LOGIN_NAME: "3f7eGY64R",
    AUTHORIZE_NET_API_LOGIN_KEY:"7p8h84Q9k6uYQj2J",
    AUTHORIZE_NET_TOKEN_URL: "https://apitest.authorize.net/xml/v1/request.api",
    // AUTHORIZE_NET_PAYMENT_URL: "https://test.authorize.net/payment/payment",
    // AUTHORIZE_NET_API_LOGIN_NAME: "5T6cxQ6t",
    // AUTHORIZE_NET_API_LOGIN_KEY:"2b33wmJuS23ac9Pu",
    // AUTHORIZE_NET_TOKEN_URL: "https://apitest.authorize.net/xml/v1/request.api",


    //for use with live
    // AUTHORIZE_NET_PAYMENT_URL: "https://accept.authorize.net/payment/payment",
    // AUTHORIZE_NET_API_LOGIN_NAME: "76N3Zq7k5",
    // AUTHORIZE_NET_API_LOGIN_KEY: "2CsD7T7x48ruw642",
    // AUTHORIZE_NET_TOKEN_URL: "https://api2.authorize.net/xml/v1/request.api",



    RegularLoyaltyConfig: "RegularLoyaltyConfig",
    GetBusinessLoyaltyConfiguration: "GetBusinessLoyaltyConfiguration",
    BGeneralLoyaltyConfig: "BGeneralLoyaltyConfig",
    PerksReward: "PerksReward",
    LoyaltyConfigType:"LoyaltyConfigType",
    GetBusinessInvoice:"GetBusinessInvoice",
    GetBusinessInvoices:"GetBusinessInvoices",
    GetPaymentProfile:"GetPaymentProfile",
    CancelBusinessSubscription:"CancelBusinessSubscription",
    UpdateBusinessSubscription:"UpdateBusinessSubscription",
    secretKey:"b1f5e8a1-6f4e-4d3e-9f4b-2c3d5e6f7a8b",
     GetStockStatusReportV3: "v3/GetStockStatusReport",
};




